import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import RichText from '@/components/atoms/rich-text/rich-text';
import RiveAnimation from '@/components/atoms/rive-animation/rive-animation';
import styles from './icon-label.module.scss';

export interface IconLabelProps {
  /** The class name to apply */
  className?: string;
  /** Indicates whether the icon has a background */
  hasIconBackground?: boolean;
  /** The icon to be displayed */
  icon?: IconName;
  /** The class name to apply to the icon */
  iconClassName?: string;
  /** Indicates whether the icon is animated */
  isAnimated?: boolean;
  /** Indicates whether it's included in product card */
  isInProductCard?: boolean;
  /** Indicates whether it's a loyalty icon */
  isLoyalty?: boolean;
  /** The text to display on the second line */
  secondLineText?: string;
  /** The text to display */
  text: string;
}

const IconLabel = ({
  className,
  hasIconBackground = false,
  icon = 'CheckMark',
  iconClassName,
  isAnimated = false,
  isInProductCard = false,
  isLoyalty = false,
  secondLineText,
  text,
}: IconLabelProps) => {
  return (
    <div
      className={classNames(styles.component, className, {
        [styles.hasBackground]: hasIconBackground,
        [styles.isAnimated]: isAnimated,
        [styles.isInProductCard]: isInProductCard,
        [styles.isLoyalty]: isLoyalty,
      })}
    >
      {isAnimated && isLoyalty ? (
        <div className={styles.animatedIconContainer}>
          <div className={styles.animatedIcon}>
            <RiveAnimation
              height={180}
              name="TravelHeartAnimatedBullet"
              width={210}
            />
          </div>
        </div>
      ) : (
        <div {...(isLoyalty && { 'data-brand': 'onehome' })}>
          <Icon
            className={classNames(styles.icon, iconClassName)}
            name={icon}
          />
        </div>
      )}

      <div className={styles.textContainer}>
        <RichText className={styles.text} text={text} />

        {secondLineText && (
          <RichText className={styles.text} text={secondLineText} />
        )}
      </div>
    </div>
  );
};

IconLabel.displayName = 'IconLabel';

export default IconLabel;
